// ==============================|| OVERRIDES - TABS ||============================== //

export default function Tabs() {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 36,
        },
        vertical: {
          overflow: 'visible'
        }
      }
    }
  };
}
